import React from "react";
import {connect} from "react-redux";
import sortBy from "lodash/sortBy";

import PRICING_POPUP_TYPES from "./pricingPopupTypes";
import PricingPopupContext, {usePricingPopupContext} from "./PricingPopupContext";
import {setLocalStorageItem} from "../../../utilities/storageFunctions";
import {setPricingCatalogs, setPricingFeatureGroupsChecked, setPricingFeaturesColumns} from "../pricingActions";
import uuid from "uuid";

const PricingPopupSaveButton = (props) => {

  const {closePopup, pricingPopupType, setPricingFeaturesColumns, setPricingFeatureGroupsChecked, pricingCatalogs,
    setPricingCatalogs, pricingGroupName} = props;

  const {pricingPopupState} = usePricingPopupContext(PricingPopupContext);
  const {featuresProperties, featureGroupsChecked, allCatalogsChecked} = pricingPopupState;

  const saveClick = () => {
    switch (pricingPopupType) {
      case PRICING_POPUP_TYPES.featuresProperties:
        setLocalStorageItem("pricingFeaturesColumns", JSON.stringify(featuresProperties));
        setPricingFeaturesColumns(featuresProperties);
        break;
      case PRICING_POPUP_TYPES.featureGroups:
        setLocalStorageItem("pricingFeatureGroupsChecked", JSON.stringify(featureGroupsChecked));
        setPricingFeatureGroupsChecked(featureGroupsChecked);
        break;
      case PRICING_POPUP_TYPES.allCatalogs:
        setPricingCatalogs(sortBy([...pricingCatalogs, ...allCatalogsChecked.map(catalog => {
          return {
            id: uuid.v4(),
            name: catalog.name,
            newCustomName: catalog.name,
            groupName: pricingGroupName,
            needToSaveCatalog: true,
            isActive: false,
          }
        })], "id"));
        break;
    }
    closePopup(false);
  };

  return (
    <button className="ui-button2 bold ui-button2--green ml-05" onClick={saveClick}>Save</button>
  )
};

const mapStateToProps = (store) => {
  const {pricingPopupType, pricingCatalogs, pricingGroupName} = store.pricingState;
  return {
    pricingPopupType,
    pricingCatalogs,
    pricingGroupName,
  };
};

const mapDispatchToProps = {
  setPricingFeaturesColumns,
  setPricingFeatureGroupsChecked,
  setPricingCatalogs,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(PricingPopupSaveButton)
)
